<template>
  <div id="sentryManagement">
    <div class="title_bar">
      <div class="left">
        <div class="sort-ctrl">
          <el-switch
            v-model="listSortable"
            active-color="#12B3A4"
            inactive-color="#dcdfe6"
            disabled
            @click.native.prevent="changeListSortable"
          />
          <span>調整排序</span>
          <el-button
            v-show="listSortable"
            type="primary"
            size="medium"
            :disabled="!listSortable"
            round
            plain
            @click="handleSortSKollectList"
          >
            儲存排序
          </el-button>
        </div>
      </div>
      <div class="right">
        <el-button
          icon="icon-plus"
          round
          :class="{'disabled': loading || ListData.filter(item => item.SentryType === SentryType.CommunityPhone).length === maxNumber.sentry || !contract.soft || listSortable}"
          @click="openDialog('createSentry')"
        >
          {{ $t("SentryManagement.CreateSentry") }}
        </el-button>
      </div>
    </div>
    <el-table
      class="newslist"
      row-key="Id"
      :data="listSortable ? sortListData : ListData"
      :empty-text="$t('SentryManagement.EmptySentry')"
    >
      <el-table-column
        v-if="listSortable"
        label=""
        width="50"
      >
        <template>
          <i class="el-icon-d-caret" />
        </template>
      </el-table-column>
      <el-table-column
        type="index"
        min-width="45"
      />
      <el-table-column :label="$t('SentryManagement.CommunitySentry')">
        <template slot-scope="scope">
          <pre>{{ scope.row.Name }}</pre>
        </template>
      </el-table-column>
      <el-table-column v-if="isCallForwardingSwitchable">
        <template #header>
          <span>市話代表號開關</span>
          <span style="margin-left: 3px;">
            <el-tooltip placement="top">
              <div
                v-if="contract.callForwarding"
                slot="content"
              >
                {{ $t("SentryManagement.HaveCallForwardingTooltip")[0] }}<br>
                {{ $t("SentryManagement.HaveCallForwardingTooltip")[1] }}
              </div>
              <div
                v-else
                slot="content"
              >
                {{ $t("SentryManagement.NotHaveCallForwardingTooltip")[0] }}<br>
                {{ $t("SentryManagement.NotHaveCallForwardingTooltip")[1] }}<br>
                {{ $t("SentryManagement.NotHaveCallForwardingTooltip")[2] }}<a
                  class="tooltip-href"
                  href="https://www.smartdaily.com.tw/intercom-qa/"
                  target="_blank"
                >點此查看方案詳情</a>
              </div>
              <i :class="contract.callForwarding ? 'icon-check-circle' : 'icon-filled-info'" />
            </el-tooltip>
          </span>
        </template>
        <template slot-scope="scope">
          <el-switch
            v-if="scope.row.SentryType !== SentryType.EntryPoint"
            :value="scope.row.IsCallBackSubscriber"
            :disabled="!contract.callForwarding"
            @change="changeCallBack(scope.row.Id, scope.row.IsCallBackSubscriber, scope.row.Name)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="CreateAt"
        label="建立日期"
        :width="isCallForwardingSwitchable ? 140 : ''"
        :min-width="40"
      >
        <template slot-scope="scope">
          {{ scope.row.CreateAt.split(':')[0] }}:{{ scope.row.CreateAt.split(':')[1] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="DeviceCount"
        label="已開通裝置數"
        :width="isCallForwardingSwitchable ? 150 : ''"
        :min-width="60"
        align="center"
      >
        <template slot-scope="scope">
          <span class="deviceCount">{{ scope.row.DeviceCount !== null ? scope.row.DeviceCount : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        :label="$t('General.Operation')"
        width="350"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.SentryType === SentryType.CommunityPhone">
            <el-button
              size="mini"
              plain
              :disabled="listSortable"
              @click="openDialog('management', scope)"
            >
              {{ $t("SentryManagement.SentryManagement") }}
            </el-button>
            <el-button
              size="mini"
              plain
              :class="{'disabled': !contract.soft || (comId==='17041003' && scope.row.Name.includes('審核用對講機')) }"
              :disabled="listSortable || (comId==='17041003' && scope.row.Name.includes('審核用對講機'))"
              @click="openDialog('createSn', scope)"
            >
              {{ $t("SentryManagement.CreateSentrySn") }}
            </el-button>
            <el-button
              type="danger"
              size="mini"
              :class="{'disabled': !contract.soft || (comId==='17041003' && scope.row.Name.includes('審核用對講機')), 'click-disabled': scope.row.IsCallBackSubscriber && isCallForwardingSwitchable}"
              plain
              :disabled="listSortable || (comId==='17041003' && scope.row.Name.includes('審核用對講機'))"
              @click="openDialog('delete', scope)"
            >
              {{ $t("SentryManagement.DeleteSentry" ) }}
            </el-button>
          </template>
          <template v-else-if="scope.row.SentryType === SentryType.VoipPhone">
            <el-button
              size="mini"
              plain
              :disabled="listSortable"
              @click="openDialog('hardwareManagement', scope)"
            >
              {{ $t("SentryManagement.HardwareSentryManagement") }}
            </el-button>
          </template>
          <template v-else-if="scope.row.SentryType === SentryType.EntryPoint">
            <el-button
              size="mini"
              plain
              :disabled="listSortable"
              @click="openDialog('softDoorManagement', scope)"
            >
              {{ $t("SentryManagement.SoftDoorManagement") }}
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
    <el-dialog
      id="createSnDialog"
      :visible.sync="isCreateSnDialogShow"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <p class="dialog-title">
          {{ $t("SentryManagement.SentrySn") }}
        </p>
        <p class="dialog-subTitle">
          {{ $t("SentryManagement.SentrySnSubTitle") }}
        </p>
      </div>
      <div v-loading="!selectedSentry.Name">
        <p class="createSnDialogContentTitle">
          <pre>{{ selectedSentry.Name }}</pre>
        </p>
        <div
          v-if="newSentrySn"
          class="createSnDialogContent sn-block"
        >
          <span class="sn">{{ newSentrySn }}</span>
        </div>
        <div class="createSnDialogNote">
          <p>{{ $t("SentryManagement.SentryNote")[0][0] }}<b>{{ $t("SentryManagement.SentryNote")[0][1] }}</b>{{ $t("SentryManagement.SentryNote")[0][2] }}</p>
          <p>{{ $t("SentryManagement.SentryNote")[1] }}</p>
          <p>{{ $t("SentryManagement.SentryNote")[2] }}</p>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      id="createSentryDialog"
      :title="$t('SentryManagement.CreateSentry')"
      :visible.sync="isCreateSentryDialogShow"
      :close-on-click-modal="false"
      custom-class="sm-size"
    >
      <p class="dialog-label">
        {{ $t("SentryManagement.CreateSentry") }}
      </p>
      <el-input
        v-model="newSentry.Name"
        class="createSentryDialogInput"
        autocomplete="off"
        :placeholder="$t('SentryManagement.CreateSentryPlaceholder')"
        maxlength="20"
      />
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          round
          :class="{'disabled': !newSentry.Name.trim()}"
          @click="createSentry"
        >新增</el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="sentryManagementDialog"
      :visible.sync="isSentryManagementDialogShow"
      :before-close="closeHousehold"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <p class="dialog-title">
          {{ $t("SentryManagement.SentryManagement") }}
        </p>
        <p class="dialog-subTitle">
          {{ $t("SentryManagement.SentryManagementSubTitle") }}
        </p>
      </div>
      <el-tabs
        id="feeTab"
        v-model="softwareSentryActiveName"
      >
        <el-tab-pane name="information">
          <span slot="label">{{ $t("SentryManagement.SentryManagementInformation") }}</span>
        </el-tab-pane>
        <el-tab-pane name="householdName">
          <span slot="label">{{ $t("SentryManagement.SentryManagementHousehold") }}</span>
        </el-tab-pane>
      </el-tabs>
      <div
        v-show="softwareSentryActiveName == 'information'"
        v-loading="!selectedSentry.Name"
      >
        <p class="dialog-label">
          {{ $t("SentryManagement.SentryName") }}
        </p>
        <el-input
          v-model="newSentry.Name"
          class="sentryManagementDialogInput"
          autocomplete="off"
          :placeholder="$t('SentryManagement.CreateSentryPlaceholder')"
          maxlength="20"
          :disabled="!contract.soft"
        />
        <el-button
          size="mini"
          type="primary"
          plain
          :class="{'disabled': !newSentry.Name.trim() || !contract.soft}"
          @click="editSentry(false)"
        >
          儲存
        </el-button>
        <p class="sentryDeviceListTitle">
          <pre>{{ selectedSentry.Name }} 的對講裝置列表</pre>
        </p>
        <el-table
          class="newslist"
          :data="selectedSentry.Devices"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            width="50"
          />
          <el-table-column
            prop="Name"
            label="對講裝置代稱"
          />
          <el-table-column
            prop="Note"
            label="裝置備註"
          />
          <el-table-column
            :label="$t('General.Operation')"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                :class="{'disabled': !contract.soft}"
                plain
                @click="clickEditDevice(scope)"
              >
                編輯
              </el-button>
              <el-button
                type="danger"
                size="mini"
                :class="{'disabled': !contract.soft}"
                plain
                @click="clickRemoveDevice(scope)"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        v-show="softwareSentryActiveName == 'householdName'"
        v-loading="!selectedSentry.Name"
      >
        <div class="allow-hint">
          <ul>
            <li>{{ $t("SentryManagement.SentryHouseholdHint")[0] }}</li>
            <li>{{ $t("SentryManagement.SentryHouseholdHint")[1] }}</li>
            <li>{{ $t("SentryManagement.SentryHouseholdHint")[2] }}</li>
          </ul>
        </div>
        <div class="dialog-label">
          {{ $t('SentryManagement.AllCommunityEnable') }}
          <el-switch
            v-model="allowList.AccessMode"
            active-color="#12B3A4"
            inactive-color="#dcdfe6"
            :active-value="1"
            :inactive-value="2"
          />
        </div>
        <div class="household-filter">
          <el-select
            v-model="chooseTower"
            class="household-select"
            :placeholder="$t('SentryManagement.SelectTower')"
            :disabled="allowList.AccessMode == 1"
          >
            <el-option
              v-for="tower in towerData"
              :key="tower.Tag"
              :label="tower.Tag"
              :value="tower.Tag"
              :disabled="allowList.AllowTags && allowList.AllowTags.find((x) => x == tower.Tag) != undefined"
            />
          </el-select>
          <el-select
            v-model="chooseFloor"
            class="household-select"
            :placeholder="$t('SentryManagement.SelectFloor')"
            :disabled="!chooseTower"
          >
            <el-option
              :label="$t('SentryManagement.SelectAll')"
              :value="'all'"
              :disabled="allowList.AllowTags && allowList.AllowTags.find((x) => x == chooseTower) != undefined"
            />
            <el-option
              v-for="floor in floorData"
              :key="floor.Floor"
              :label="$t('Household.Floor', {floor: floor.Floor})"
              :value="floor.Floor"
              :disabled="(allowList.AllowTags && allowList.AllowFloors.find((x) => x.Floor == floor.Floor && x.FloorTag == chooseTower) != undefined) || (allowList.AllowTags && allowList.AllowTags.find((x) => x == chooseTower) != undefined)"
            />
          </el-select>
          <el-select
            v-model="chooseHousehold"
            class="household-select"
            multiple
            collapse-tags
            :placeholder="$t('SentryManagement.SelectHousehold')"
            :disabled="!chooseFloor || chooseFloor == 'all'"
          >
            <el-option
              :label="$t('SentryManagement.SelectAll')"
              :value="'all'"
              :disabled="(allowList.AllowTags && allowList.AllowFloors.find((x) => x.Floor == chooseFloor && x.FloorTag == chooseTower) != undefined) || (allowList.AllowTags && allowList.AllowTags.find((x) => x == chooseTower) != undefined)"
            />
            <el-option
              v-for="tablet in tabletData"
              :key="tablet.TabletId"
              :label="tablet.TabletNote"
              :value="tablet.TabletId"
              :disabled="chooseHousehold.includes('all') || (allowList.AllowTags && (allowList.AllowTablets.find((x) => x.TabletId == tablet.TabletId) != undefined || allowList.AllowFloors.find((x) => x.Floor == chooseFloor && x.FloorTag == chooseTower) != undefined || allowList.AllowTags.find((x) => x == chooseTower) != undefined))"
            />
          </el-select>
          <el-button
            icon="icon-plus"
            class="store-btn"
            round
            :disabled="chooseTower == '' || (chooseTower != '' && chooseFloor == '') || (chooseTower != '' && (chooseFloor != '' && chooseFloor != 'all') && chooseHousehold.length <= 0)"
            @click="addWhiteTag"
          >
            新增
          </el-button>
        </div>
        <div class="household-tags-content">
          <template v-if="allowList.AccessMode != 1 && allowList.AllowTags && allowList.AllowTags.length <= 0 && allowList.AllowFloors && allowList.AllowFloors.length <= 0 && allowList.AllowTablets && allowList.AllowTablets.length <= 0">
            <div class="no-household-content">
              <div>
                {{ $t("SentryManagement.SentryHouseholdEmpty")[0] }}
              </div>
              <div style="margin-top: 10px">
                {{ $t("SentryManagement.SentryHouseholdEmpty")[1] }}
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="allowList.AccessMode == 1">
              <el-tag
                closable
                :disable-transitions="true"
                @close="allowList.AccessMode = 2"
              >
                {{ $t('SentryManagement.AllCommunityTag') }}
              </el-tag>
            </template>
            <template>
              <el-tag
                v-for="tower in allowList.AllowTags"
                :key="tower"
                closable
                :disable-transitions="true"
                @close="deleteTower(tower)"
              >
                {{ $t('SentryManagement.TowerAllTag', { tower }) }}
              </el-tag>
            </template>
            <template>
              <el-tag
                v-for="floor in allowList.AllowFloors"
                :key="floor.Floor"
                closable
                :disable-transitions="true"
                @close="deleteFloor(floor)"
              >
                {{ $t('SentryManagement.FloorAllTag', { floorTag: floor.FloorTag, floor: floor.Floor }) }}
              </el-tag>
            </template>
            <template>
              <el-tag
                v-for="household in allowList.AllowTablets"
                :key="household.TabletId"
                closable
                :disable-transitions="true"
                @close="deleteHousehold(household)"
              >
                {{ household.TabletNote }}
              </el-tag>
            </template>
          </template>
        </div>
      </div>
      <span
        v-if="softwareSentryActiveName == 'householdName'"
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="danger"
          round
          @click="clearHousehold"
        >{{ $t('General.ClearAll') }}</el-button>
        <el-button
          round
          @click="closeHousehold"
        >{{ $t('General.Cancel') }}</el-button>
        <el-button
          type="primary"
          round
          @click="storeHoudehold"
        >儲存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="editDeviceDialog"
      :visible.sync="isEditDeviceDialogShow"
      :close-on-click-modal="false"
      custom-class="sm-size"
    >
      <div slot="title">
        <p class="dialog-title">
          編輯裝置資訊
        </p>
        <p class="dialog-subTitle">
          可以編輯裝置代稱與備註
        </p>
      </div>
      <p class="dialog-label">
        對講裝置代稱
      </p>
      <el-input
        v-model="newDevice.Name"
        class="editDeviceDialogInput"
        maxlength="20"
      />
      <p class="dialog-label">
        裝置備註
      </p>
      <el-input
        v-model="newDevice.Note"
        type="textarea"
        class="editDeviceDialogTextarea"
        maxlength="80"
        show-word-limit
        rows="5"
        :placeholder="$t('SentryManagement.DeviceNotePlaceholder')"
      />
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="isEditDeviceDialogShow = false"
        >{{ $t('General.Cancel') }}</el-button>
        <el-button
          type="primary"
          round
          :class="{'disabled': !newDevice.Name.trim()}"
          @click="editDevice"
        >儲存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="hardwareSentryManagementDialog"
      :visible.sync="isHardwareSentryManagementDialogShow"
      :before-close="closeHousehold"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <p class="dialog-title">
          {{ $t("SentryManagement.HardwareSentryManagement") }}
        </p>
        <p class="dialog-subTitle">
          {{ $t("SentryManagement.HardwareSentryManagementSubTitle") }}
        </p>
      </div>
      <el-tabs
        id="feeTab"
        v-model="hardwareSentryActiveName"
      >
        <el-tab-pane name="information">
          <span slot="label">{{ $t("SentryManagement.SentryManagementInformation") }}</span>
        </el-tab-pane>
        <el-tab-pane name="householdName">
          <span slot="label">{{ $t("SentryManagement.SentryManagementHousehold") }}</span>
        </el-tab-pane>
      </el-tabs>
      <div
        v-show="hardwareSentryActiveName == 'information'"
        v-loading="!selectedSentry.Name"
      >
        <p class="dialog-label">
          {{ $t("SentryManagement.HardwareSentryName") }}
        </p>
        <el-input
          v-model="newSentry.Name"
          class="editDeviceDialogInput"
          maxlength="20"
          :disabled="!contract.hard"
        />
        <p class="dialog-label">
          {{ $t("SentryManagement.HardwareSentryNote") }}
        </p>
        <el-input
          v-model="newSentry.Note"
          type="textarea"
          class="editDeviceDialogTextarea"
          maxlength="80"
          show-word-limit
          rows="5"
          :placeholder="$t('SentryManagement.DeviceNotePlaceholder')"
          :disabled="!contract.hard"
        />
        <el-checkbox
          v-model="newSentry.OpenDoorFeature"
          class="editDeviceDialogCheckbox"
        >
          通話中顯示遠端開門按鈕
        </el-checkbox>
      </div>
      <div
        v-show="hardwareSentryActiveName == 'householdName'"
        v-loading="!selectedSentry.Name"
      >
        <div class="allow-hint">
          <ul>
            <li>{{ $t("SentryManagement.SentryHouseholdHint")[0] }}</li>
            <li>{{ $t("SentryManagement.SentryHouseholdHint")[1] }}</li>
            <li>{{ $t("SentryManagement.SentryHouseholdHint")[2] }}</li>
          </ul>
        </div>
        <div class="dialog-label">
          {{ $t('SentryManagement.AllCommunityEnable') }}
          <el-switch
            v-model="allowList.AccessMode"
            active-color="#12B3A4"
            inactive-color="#dcdfe6"
            :active-value="1"
            :inactive-value="2"
          />
        </div>
        <div class="household-filter">
          <el-select
            v-model="chooseTower"
            class="household-select"
            :placeholder="$t('SentryManagement.SelectTower')"
            :disabled="allowList.AccessMode == 1"
          >
            <el-option
              v-for="tower in towerData"
              :key="tower.Tag"
              :label="tower.Tag"
              :value="tower.Tag"
              :disabled="allowList.AllowTags && allowList.AllowTags.find((x) => x == tower.Tag) != undefined"
            />
          </el-select>
          <el-select
            v-model="chooseFloor"
            class="household-select"
            :placeholder="$t('SentryManagement.SelectFloor')"
            :disabled="!chooseTower"
          >
            <el-option
              :label="$t('SentryManagement.SelectAll')"
              :value="'all'"
              :disabled="allowList.AllowTags && allowList.AllowTags.find((x) => x == chooseTower) != undefined"
            />
            <el-option
              v-for="floor in floorData"
              :key="floor.Floor"
              :label="$t('Household.Floor', {floor: floor.Floor})"
              :value="floor.Floor"
              :disabled="(allowList.AllowTags && allowList.AllowFloors.find((x) => x.Floor == floor.Floor && x.FloorTag == chooseTower) != undefined) || (allowList.AllowTags && allowList.AllowTags.find((x) => x == chooseTower) != undefined)"
            />
          </el-select>
          <el-select
            v-model="chooseHousehold"
            class="household-select"
            multiple
            collapse-tags
            :placeholder="$t('SentryManagement.SelectHousehold')"
            :disabled="!chooseFloor || chooseFloor == 'all'"
          >
            <el-option
              :label="$t('SentryManagement.SelectAll')"
              :value="'all'"
              :disabled="(allowList.AllowTags && allowList.AllowFloors.find((x) => x.Floor == chooseFloor && x.FloorTag == chooseTower) != undefined) || (allowList.AllowTags && allowList.AllowTags.find((x) => x == chooseTower) != undefined)"
            />
            <el-option
              v-for="tablet in tabletData"
              :key="tablet.TabletId"
              :label="tablet.TabletNote"
              :value="tablet.TabletId"
              :disabled="chooseHousehold.includes('all') || (allowList.AllowTags && (allowList.AllowTablets.find((x) => x.TabletId == tablet.TabletId) != undefined || allowList.AllowFloors.find((x) => x.Floor == chooseFloor && x.FloorTag == chooseTower) != undefined || allowList.AllowTags.find((x) => x == chooseTower) != undefined))"
            />
          </el-select>
          <el-button
            icon="icon-plus"
            class="store-btn"
            round
            :disabled="chooseTower == '' || (chooseTower != '' && chooseFloor == '') || (chooseTower != '' && (chooseFloor != '' && chooseFloor != 'all') && chooseHousehold.length <= 0)"
            @click="addWhiteTag"
          >
            新增
          </el-button>
        </div>
        <div class="household-tags-content">
          <template v-if="allowList.AccessMode != 1 && allowList.AllowTags && allowList.AllowTags.length <= 0 && allowList.AllowFloors && allowList.AllowFloors.length <= 0 && allowList.AllowTablets && allowList.AllowTablets.length <= 0">
            <div class="no-household-content">
              <div>
                {{ $t("SentryManagement.SentryHouseholdEmpty")[0] }}
              </div>
              <div style="margin-top: 10px">
                {{ $t("SentryManagement.SentryHouseholdEmpty")[1] }}
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="allowList.AccessMode == 1">
              <el-tag
                closable
                :disable-transitions="true"
                @close="allowList.AccessMode = 2"
              >
                {{ $t('SentryManagement.AllCommunityTag') }}
              </el-tag>
            </template>
            <template>
              <el-tag
                v-for="tower in allowList.AllowTags"
                :key="tower"
                closable
                :disable-transitions="true"
                @close="deleteTower(tower)"
              >
                {{ $t('SentryManagement.TowerAllTag', { tower }) }}
              </el-tag>
            </template>
            <template>
              <el-tag
                v-for="floor in allowList.AllowFloors"
                :key="floor.Floor"
                closable
                :disable-transitions="true"
                @close="deleteFloor(floor)"
              >
                {{ $t('SentryManagement.FloorAllTag', { floorTag: floor.FloorTag, floor: floor.Floor }) }}
              </el-tag>
            </template>
            <template>
              <el-tag
                v-for="household in allowList.AllowTablets"
                :key="household.TabletId"
                closable
                :disable-transitions="true"
                @close="deleteHousehold(household)"
              >
                {{ household.TabletNote }}
              </el-tag>
            </template>
          </template>
        </div>
      </div>
      <span
        v-if="contract.hard && hardwareSentryActiveName == 'information'"
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="isHardwareSentryManagementDialogShow = false"
        >{{ $t('General.Cancel') }}</el-button>
        <el-button
          type="primary"
          round
          :class="{'disabled': !newSentry.Name.trim() || !selectedSentry.Name}"
          @click="editHardwareSentry"
        >儲存</el-button>
      </span>
      <span
        v-if="hardwareSentryActiveName == 'householdName'"
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="danger"
          round
          @click="clearHousehold"
        >{{ $t('General.ClearAll') }}</el-button>
        <el-button
          round
          @click="closeHousehold"
        >{{ $t('General.Cancel') }}</el-button>
        <el-button
          type="primary"
          round
          @click="storeHoudehold"
        >儲存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="softDoorManagementDialog"
      :visible.sync="isSoftDoorManagementDialogShow"
      :before-close="closeHousehold"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <p class="dialog-title">
          {{ $t("SentryManagement.SoftDoorManagement") }}
        </p>
        <p class="dialog-subTitle">
          {{ $t("SentryManagement.SoftwareSentryManagementSubTitle") }}
        </p>
      </div>
      <el-tabs
        id="feeTab"
        v-model="softDoorSentryActiveName"
      >
        <el-tab-pane name="information">
          <span slot="label">{{ $t("SentryManagement.SentryManagementInformation") }}</span>
        </el-tab-pane>
        <el-tab-pane name="householdName">
          <span slot="label">{{ $t("SentryManagement.SoftDoorDialCallList") }}</span>
        </el-tab-pane>
      </el-tabs>
      <div
        v-show="softDoorSentryActiveName == 'information'"
        v-loading="!selectedSentry.Name"
      >
        <p class="dialog-label">
          {{ $t("SentryManagement.SoftwareSentryName") }}
        </p>
        <el-input
          v-model="newSentry.Name"
          class="editDeviceDialogInput"
          maxlength="20"
          :disabled="!contract.cloudGuest"
        />
        <p class="dialog-label">
          {{ $t("SentryManagement.SoftwareSentryNote") }}
        </p>
        <el-input
          v-model="newSentry.Note"
          type="textarea"
          class="editDeviceDialogTextarea"
          maxlength="80"
          show-word-limit
          rows="5"
          :placeholder="$t('SentryManagement.DeviceNotePlaceholder')"
          :disabled="!contract.cloudGuest"
        />
      </div>
      <div
        v-show="softDoorSentryActiveName == 'householdName'"
        v-loading="!selectedSentry.Name"
      >
        <div class="allow-hint">
          <ul>
            <li>{{ $t("SentryManagement.SoftDoorHouseholdHint") }}</li>
          </ul>
        </div>
        <div class="dialog-label">
          {{ $t('SentryManagement.AllCommunityEnable') }}
          <el-switch
            v-model="allowList.AccessMode"
            active-color="#12B3A4"
            inactive-color="#dcdfe6"
            :active-value="1"
            :inactive-value="2"
            :disabled="!contract.cloudGuest"
          />
        </div>
        <div class="household-filter">
          <el-select
            v-model="chooseTower"
            class="household-select"
            :placeholder="$t('SentryManagement.SelectTower')"
            :disabled="allowList.AccessMode == 1 || !contract.cloudGuest"
          >
            <el-option
              v-for="tower in towerData"
              :key="tower.Tag"
              :label="tower.Tag"
              :value="tower.Tag"
              :disabled="allowList.AllowTags && allowList.AllowTags.find((x) => x == tower.Tag) != undefined"
            />
          </el-select>
          <el-select
            v-model="chooseFloor"
            class="household-select"
            :placeholder="$t('SentryManagement.SelectFloor')"
            :disabled="!chooseTower || !contract.cloudGuest"
          >
            <el-option
              :label="$t('SentryManagement.SelectAll')"
              :value="'all'"
              :disabled="allowList.AllowTags && allowList.AllowTags.find((x) => x == chooseTower) != undefined"
            />
            <el-option
              v-for="floor in floorData"
              :key="floor.Floor"
              :label="$t('Household.Floor', {floor: floor.Floor})"
              :value="floor.Floor"
              :disabled="(allowList.AllowTags && allowList.AllowFloors.find((x) => x.Floor == floor.Floor && x.FloorTag == chooseTower) != undefined) || (allowList.AllowTags && allowList.AllowTags.find((x) => x == chooseTower) != undefined)"
            />
          </el-select>
          <el-select
            v-model="chooseHousehold"
            class="household-select"
            multiple
            collapse-tags
            :placeholder="$t('SentryManagement.SelectHousehold')"
            :disabled="!chooseFloor || chooseFloor == 'all' || !contract.cloudGuest"
          >
            <el-option
              :label="$t('SentryManagement.SelectAll')"
              :value="'all'"
              :disabled="(allowList.AllowTags && allowList.AllowFloors.find((x) => x.Floor == chooseFloor && x.FloorTag == chooseTower) != undefined) || (allowList.AllowTags && allowList.AllowTags.find((x) => x == chooseTower) != undefined)"
            />
            <el-option
              v-for="tablet in tabletData"
              :key="tablet.TabletId"
              :label="tablet.TabletNote"
              :value="tablet.TabletId"
              :disabled="chooseHousehold.includes('all') || (allowList.AllowTags && (allowList.AllowTablets.find((x) => x.TabletId == tablet.TabletId) != undefined || allowList.AllowFloors.find((x) => x.Floor == chooseFloor && x.FloorTag == chooseTower) != undefined || allowList.AllowTags.find((x) => x == chooseTower) != undefined))"
            />
          </el-select>
          <el-button
            icon="icon-plus"
            class="store-btn"
            round
            :disabled="!contract.cloudGuest || chooseTower == '' || (chooseTower != '' && chooseFloor == '') || (chooseTower != '' && (chooseFloor != '' && chooseFloor != 'all') && chooseHousehold.length <= 0)"
            @click="addWhiteTag"
          >
            新增
          </el-button>
        </div>
        <div class="household-tags-content">
          <template v-if="allowList.AccessMode != 1 && allowList.AllowTags && allowList.AllowTags.length <= 0 && allowList.AllowFloors && allowList.AllowFloors.length <= 0 && allowList.AllowTablets && allowList.AllowTablets.length <= 0">
            <div class="no-household-content">
              <div>
                {{ $t("SentryManagement.SentryHouseholdEmpty")[0] }}
              </div>
              <div style="margin-top: 10px">
                {{ $t("SentryManagement.SentryHouseholdEmpty")[1] }}
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="allowList.AccessMode == 1">
              <el-tag
                closable
                :disable-transitions="true"
                @close="allowList.AccessMode = 2"
              >
                {{ $t('SentryManagement.AllCommunityTag') }}
              </el-tag>
            </template>
            <template>
              <el-tag
                v-for="tower in allowList.AllowTags"
                :key="tower"
                closable
                :disable-transitions="true"
                @close="deleteTower(tower)"
              >
                {{ $t('SentryManagement.TowerAllTag', { tower }) }}
              </el-tag>
            </template>
            <template>
              <el-tag
                v-for="floor in allowList.AllowFloors"
                :key="floor.Floor"
                closable
                :disable-transitions="true"
                @close="deleteFloor(floor)"
              >
                {{ $t('SentryManagement.FloorAllTag', { floorTag: floor.FloorTag, floor: floor.Floor }) }}
              </el-tag>
            </template>
            <template>
              <el-tag
                v-for="household in allowList.AllowTablets"
                :key="household.TabletId"
                closable
                :disable-transitions="true"
                @close="deleteHousehold(household)"
              >
                {{ household.TabletNote }}
              </el-tag>
            </template>
          </template>
        </div>
      </div>
      <span
        v-if="contract.cloudGuest && softDoorSentryActiveName == 'information'"
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="isSoftDoorManagementDialogShow = false"
        >{{ $t('General.Cancel') }}</el-button>
        <el-button
          type="primary"
          round
          :class="{'disabled': !newSentry.Name.trim() || !selectedSentry.Name}"
          @click="editSoftDoorSentry"
        >儲存</el-button>
      </span>
      <span
        v-if="softDoorSentryActiveName == 'householdName'"
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="danger"
          round
          @click="clearHousehold"
        >{{ $t('General.ClearAll') }}</el-button>
        <el-button
          round
          @click="closeHousehold"
        >{{ $t('General.Cancel') }}</el-button>
        <el-button
          type="primary"
          round
          @click="storeHoudehold"
        >儲存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import Sortable from 'sortablejs'
import { SentryType } from './models/index'
export default {
  components: {
    TableLoading
  },
  data () {
    return {
      SentryType,
      towerData: [],
      floorData: [],
      tabletData: [],
      activeName: 'sentryManagement',
      softwareSentryActiveName: 'information',
      hardwareSentryActiveName: 'information',
      chooseTower: '',
      chooseFloor: '',
      chooseHousehold: [],
      chooseSentryID: 0,
      loading: false,
      ListData: [],
      sortListData: [],
      sortable: null,
      isCreateSnDialogShow: false,
      isCreateSentryDialogShow: false,
      isDeleteSentryDialogShow: false,
      isDeleteDeviceDialogShow: false,
      isSentryManagementDialogShow: false,
      isEditDeviceDialogShow: false,
      isHardwareSentryManagementDialogShow: false,
      isSoftDoorManagementDialogShow: false,
      isCheckCloseShow: false,
      listSortable: false,
      softDoorSentryActiveName: 'information',
      newSentry: {
        Name: '',
        Note: '',
        OpenDoorFeature: false
      },
      newSentrySn: '',
      newDevice: {
        Name: '',
        Note: ''
      },
      isEditDeviceNote: false,
      selectedSentry: {},
      selectedDevice: {
        index: null,
        name: null
      },
      isSending: false,
      maxNumber: {
        sentry: null,
        device: null
      },
      contract: {
        soft: false,
        hard: false,
        callForwarding: false,
        callbackEnabled: false, // 是否可回撥
        cloudGuest: false // 社區對講機-雲訪客合約是否有效
      },
      allowList: {},
      allowListBack: {},
      comId: ''
    }
  },
  computed: {
    // 有轉市話 + 可回撥，才會顯示「市話代表號開關」
    isCallForwardingSwitchable () {
      return this.contract.callForwarding && this.contract.callbackEnabled
    }
  },
  watch: {
    chooseTower: {
      handler: async function () {
        // eslint-disable-next-line eqeqeq
        if (this.chooseTower != '') {
          await this.getFloors()
          this.chooseFloor = ''
        }
      }
    },
    chooseFloor: {
      handler: async function () {
        // eslint-disable-next-line eqeqeq
        if (this.chooseFloor == 'all' || this.chooseFloor == '') this.chooseHousehold = []
        // eslint-disable-next-line eqeqeq
        else if (this.chooseFloor != '') {
          await this.getTablets()
          this.chooseHousehold = []
        }
      }
    },
    chooseHousehold: {
      handler: function (n, o) {
        // eslint-disable-next-line eqeqeq
        if ((!o.includes('all') && n.includes('all')) || (this.chooseHousehold.length == this.tabletData.length && this.chooseHousehold.length > 0 && !this.chooseHousehold.includes('all'))) {
          this.chooseHousehold = ['all']
        }
      }
    },
    'allowList.AccessMode': {
      handler: function () {
        // eslint-disable-next-line eqeqeq
        if (this.allowList.AccessMode == 1) {
          this.allowList.AllowTags = []
          this.allowList.AllowFloors = []
          this.allowList.AllowTablets = []
          this.chooseTower = ''
          this.chooseFloor = ''
          this.chooseHousehold = []
        }
      }
    },
    'allowList.AllowTags': {
      handler: function () { this.checkTowerAllChoose() },
      deep: true
    },
    'allowList.AllowFloors': {
      handler: function () { this.checkFloorAllChoose() },
      deep: true
    },
    'allowList.AllowTablets': {
      handler: function () { this.checkHouseholdAllChoose() },
      deep: true
    },
    listSortable: {
      handler: function () {
        if (this.listSortable) {
          this.sortListData = this.ListData.concat()
          this.startDraggable()
        } else this.endDraggable()
      }
    },
    isSentryManagementDialogShow: {
      handler: function () {
        if (!this.isSentryManagementDialogShow) {
          this.floorData = []
          this.tabletData = []
          this.chooseTower = ''
          this.chooseFloor = ''
          this.chooseHousehold = []
          this.chooseSentryID = 0
          this.allowList = {}
          this.allowListBack = {}
        }
      }
    },
    isSoftDoorManagementDialogShow: {
      handler: function () {
        if (!this.isSoftDoorManagementDialogShow) {
          this.floorData = []
          this.tabletData = []
          this.chooseTower = ''
          this.chooseFloor = ''
          this.chooseHousehold = []
          this.chooseSentryID = 0
          this.allowList = {}
          this.allowListBack = {}
          this.softDoorSentryActiveName = 'information'
        }
      }
    }
  },
  mounted () {
    if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount && !JSON.parse(localStorage.getItem('loginUserInfo')).IsFromEip) {
      this.$alert('沒有訪問權限', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        this.$router.back()
      })
      return false
    }
    this.comId = JSON.parse(localStorage.getItem('loginUserInfo')).ComId
    this.getSentryList()
    this.getMaxNumber()
    this.getContract()
    this.getTags()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
  },
  methods: {
    getMaxNumber () {
      apiIntercom.Sentry.GetMaxNumber().then(res => {
        this.maxNumber.sentry = res.data.Data.MaxNumberOfSentries
        this.maxNumber.device = res.data.Data.MaxNumberOfDevicesPerSentry
      }).catch(err => {
        console.log(err)
      })
    },
    async getContract () {
      try {
        const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
        const isAdmin = loginUserInfo.IsAdmin
        const isFromEip = loginUserInfo.IsFromEip
        await this.$store.state.intercom.contractPromise // 等待合約資料讀取完成
        const contract = this.$store.state.intercom.contract
        this.contract.soft = contract.SoftContractPeriod && (isAdmin || isFromEip)
        this.contract.hard = contract.HardContractPeriod && (isAdmin || isFromEip)
        this.contract.callForwarding = this.$store.getters['intercom/hasCallForwarding']
        this.contract.callbackEnabled = this.$store.getters['intercom/isCallbackEnabled']
        this.contract.cloudGuest = this.$store.getters['intercom/hasCloudGuest'] && (isAdmin || isFromEip)
      } catch (err) {
        console.log(err)
      }
    },
    getSentryList () {
      this.loading = true
      apiIntercom.Sentry.GetSentryList2().then(res => {
        this.ListData = res.data.Data.Sentries
        this.ListData.sort((a, b) => a.Sort > b.Sort)
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    getSentry (scope) {
      this.selectedSentry = {}
      apiIntercom.Sentry.GetSentry(scope.row.Id).then(res => {
        this.selectedSentry = res.data.Data
        this.selectedSentry.Index = scope.$index
        this.newSentry.Name = res.data.Data.Name
        this.newSentry.Note = res.data.Data.Note
        this.newSentry.OpenDoorFeature = !!(res.data.Data.PluginsTypes && res.data.Data.PluginsTypes.indexOf(1) !== -1)
        if (this.ListData[scope.$index].DeviceCount !== null) {
          this.ListData[scope.$index].DeviceCount = res.data.Data.Devices.length
        }
      }).catch(err => {
        console.log(err)
        if (err.response.data.ErrorMessage.Code === 404000) {
          this.$message({
            message: this.$t('SentryManagement.SentryDeleted'),
            type: 'error'
          })
          setTimeout(() => {
            this.isCreateSnDialogShow = false
            this.isSentryManagementDialogShow = false
            this.isHardwareSentryManagementDialogShow = false
          }, 1000)
        }
      })
    },
    async getTags () {
      await apiIntercom.Community.GetTags().then((res) => {
        const { data } = res
        // eslint-disable-next-line eqeqeq
        if (data.Status == 1) this.towerData = data.Data.Tags
      }).catch((err) => {
        console.log(err)
      })
    },
    async getFloors () {
      await apiIntercom.Community.GetFloors(this.chooseTower).then((res) => {
        const { data } = res
        // eslint-disable-next-line eqeqeq
        if (data.Status == 1) this.floorData = data.Data.Floors
      }).catch((err) => {
        console.log(err)
      })
    },
    async getTablets () {
      await apiIntercom.Community.GetTablets(this.chooseTower, this.chooseFloor).then((res) => {
        const { data } = res
        // eslint-disable-next-line eqeqeq
        if (data.Status == 1) this.tabletData = data.Data.Tablets
      }).catch((err) => {
        console.log(err)
      })
    },
    async getDefaultAllowlist (sentryID, onlyUpdateBack = false) {
      await apiIntercom.Sentry.GetSentryAllowlist(sentryID).then((res) => {
        const { data } = res
        // eslint-disable-next-line eqeqeq
        if (data.Status == 1) {
          if (!onlyUpdateBack) this.allowList = JSON.parse(JSON.stringify(data.Data))
          this.allowListBack = JSON.parse(JSON.stringify(data.Data))
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    async openDialog (mode, scope) {
      document.querySelectorAll('button').forEach(item => {
        item.blur()
      })
      if (mode === 'createSentry') {
        this.newSentry.Name = ''
        this.newSentry.Note = ''
        this.isCreateSentryDialogShow = true
      } else {
        this.getSentry(scope)
        if (mode === 'createSn') {
          if (scope.row.DeviceCount >= this.maxNumber.device) {
            this.$message({
              message: this.$t('SentryManagement.SentryDeviceMax', { count: this.maxNumber.device }),
              type: 'warning'
            })
            return
          }
          this.newSentrySn = ''
          this.createSentrySn(scope.row.Id)
          this.isCreateSnDialogShow = true
        } else if (mode === 'delete') {
          /**
           * 1. 如果 IsCallBackSubscriber = true => 啟用市話回撥中，不能刪除
           * 2. 若此時 isCallForwardingSwitchable = false => 市話代表號開關欄位隱藏中，則可以刪除
           */
          if (scope.row.IsCallBackSubscriber && this.isCallForwardingSwitchable) {
            this.$message({
              message: '刪除失敗，請切換市話代表號的開關再執行刪除',
              type: 'warning'
            })
            return
          }
          this.clickDeleteSentry(scope.row.Id)
        } else if (mode === 'management') {
          this.chooseSentryID = scope.row.Id
          await this.getDefaultAllowlist(scope.row.Id)
          this.isSentryManagementDialogShow = true
        } else if (mode === 'hardwareManagement') {
          this.chooseSentryID = scope.row.Id
          await this.getDefaultAllowlist(scope.row.Id)
          this.isHardwareSentryManagementDialogShow = true
        } else if (mode === 'softDoorManagement') {
          this.chooseSentryID = scope.row.Id
          await this.getDefaultAllowlist(scope.row.Id)
          this.isSoftDoorManagementDialogShow = true
        }
      }
    },
    createSentrySn (id) {
      if (!this.isSending) {
        this.isSending = true
        apiIntercom.Sentry.PostSentrySn(id).then(res => {
          this.newSentrySn = res.data.Data.SerialNumber
          this.isSending = false
        }).catch(err => {
          console.log(err)
          this.isSending = false
        })
      }
    },
    createSentry () {
      if (!this.isSending) {
        this.isSending = true
        const config = {
          metadata: {
            userHandlesErrors: true
          }
        }
        apiIntercom.Sentry.PostSentry({
          Name: this.newSentry.Name,
          Note: this.newSentry.Note
        }, config).then(res => {
          this.getSentryList()
          this.isCreateSentryDialogShow = false
          this.$message({
            message: this.$t('Intercom.CreateSentrySuccess'),
            type: 'success'
          })
          setTimeout(() => {
            this.isSending = false
          }, 500)
        }).catch(err => {
          console.log(err)
          if (err.response.data.ErrorMessage.Code === 400006) {
            this.$message({
              message: this.$t('Intercom.CreateSentryReachesUpperLimit'),
              type: 'error'
            })
          }
          setTimeout(() => {
            this.isSending = false
          }, 500)
        })
      }
    },
    editSentry (isHardware) {
      if (!this.isSending) {
        this.isSending = true
        const params = {
          Name: this.newSentry.Name,
          Note: this.newSentry.Note
        }
        if (isHardware) {
          params.PluginsTypes = []
          if (this.newSentry.OpenDoorFeature) {
            params.PluginsTypes.push(1)
          }
        }
        apiIntercom.Sentry.PutSentry(this.selectedSentry.Id, params).then(res => {
          this.selectedSentry.Name = this.newSentry.Name
          this.selectedSentry.Note = this.newSentry.Note
          this.ListData[this.selectedSentry.Index].Name = this.newSentry.Name
          if (!isHardware) {
            this.$message({
              message: this.$t('SentryManagement.UpdateSentryNameSuccess'),
              type: 'success'
            })
          } else {
            this.$message({
              message: this.$t('SentryManagement.UpdateHardwareSentrySuccess'),
              type: 'success'
            })
          }
          this.isSending = false
        }).catch(err => {
          if (err.response.data.ErrorMessage.Code === 404000) {
            this.$message({
              message: this.$t('SentryManagement.SentryDeleted'),
              type: 'error'
            })
          }
          this.isSending = false
        })
      }
    },
    clickDeleteSentry (id) {
      this.$confirm(this.$t('SentryManagement.DeleteSentryConfirmBody'), this.$t('SentryManagement.DeleteSentryConfirmTitle'), {
        confirmButtonText: '刪除',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: '取消',
        closeOnClickModal: false
      }).then(action => {
        if (!this.isSending) {
          this.isSending = true
          apiIntercom.Sentry.DeleteSentry(id).then(res => {
            this.ListData.splice(this.selectedSentry.Index, 1)
            this.$message({
              message: this.$t('SentryManagement.DeleteSentrySuccess'),
              type: 'success'
            })
            this.isSending = false
          }).catch(err => {
            console.log(err)
            this.isSending = false
          })
        }
      }).catch(() => {
      })
    },
    clickEditDevice (scope) {
      this.selectedDevice = {
        Index: scope.$index,
        Id: scope.row.Id,
        Name: scope.row.Name,
        Note: scope.row.Note
      }
      this.newDevice.Name = this.selectedDevice.Name
      this.newDevice.Note = this.selectedDevice.Note
      this.isEditDeviceDialogShow = true
    },
    editDevice () {
      if (!this.isSending) {
        this.isSending = true
        apiIntercom.Sentry.PutDevice(this.selectedDevice.Id, {
          Name: this.newDevice.Name,
          Note: this.newDevice.Note
        }).then(res => {
          this.selectedSentry.Name = this.newSentry.Name
          this.selectedSentry.Note = this.newSentry.Note
          this.ListData[this.selectedSentry.Index].Name = this.newSentry.Name
          this.selectedSentry.Devices[this.selectedDevice.Index].Name = this.newDevice.Name
          this.selectedSentry.Devices[this.selectedDevice.Index].Note = this.newDevice.Note
          this.$message({
            message: '更新裝置資訊成功',
            type: 'success'
          })
          this.isEditDeviceDialogShow = false
          this.isSending = false
        }).catch(err => {
          if (err.response.data.ErrorMessage.Code === 404000) {
            this.$message({
              message: '裝置已被移除',
              type: 'error'
            })
          }
          this.isSending = false
        })
      }
    },
    clickRemoveDevice (scope) {
      this.selectedDevice = {
        Index: scope.$index,
        Id: scope.row.Id,
        Name: scope.row.Name,
        Note: scope.row.Note
      }
      this.$confirm(`確定要將 ${this.selectedDevice.Name}，從 ${this.selectedSentry.Name} 移除嗎？`, '確定移除此裝置？', {
        confirmButtonText: '移除',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: '取消',
        closeOnClickModal: false
      }).then(action => {
        if (!this.isSending) {
          this.isSending = true
          apiIntercom.Sentry.DeleteDevice(this.selectedDevice.Id).then(res => {
            this.selectedSentry.Devices.splice(this.selectedDevice.Index, 1)
            this.ListData[this.selectedSentry.Index].DeviceCount--
            this.isDeleteDeviceDialogShow = false
            this.$message({
              message: '移除對講裝置成功',
              type: 'success'
            })
            this.isSending = false
          }).catch(err => {
            console.log(err)
            this.isSending = false
          })
        }
      }).catch(() => {
      })
    },
    editHardwareSentry () {
      this.isHardwareSentryManagementDialogShow = false
      this.editSentry(true)
    },
    editSoftDoorSentry () {
      this.isSoftDoorManagementDialogShow = false
      this.editSentry(false)
    },
    addWhiteTag () {
      if (this.chooseHousehold.includes('all')) this.addFloor()
      else if (this.chooseHousehold.length > 0) this.addHousehold()
      // eslint-disable-next-line eqeqeq
      else if (this.chooseFloor == 'all') this.addTower()
      this.allowList.AccessMode = 2
      this.chooseHousehold = []
    },
    addTower () {
      // eslint-disable-next-line eqeqeq
      const isChoosed = this.allowList.AllowTags.find((x) => x == this.chooseTower)
      if (!isChoosed) this.allowList.AllowTags.push(this.chooseTower)
      this.floorData.forEach((item) => {
        // eslint-disable-next-line eqeqeq
        const index = this.allowList.AllowFloors.findIndex((x) => x.Floor == item.Floor && x.FloorTag == this.chooseTower)
        if (index >= 0) this.allowList.AllowFloors.splice(index, 1)
      })
    },
    addFloor () {
      // eslint-disable-next-line eqeqeq
      const isChoosed = this.allowList.AllowFloors.find((x) => x.FloorTag == this.chooseTower && x.Floor == this.chooseFloor)
      if (!isChoosed) {
        this.allowList.AllowFloors.push(
          {
            FloorTag: this.chooseTower,
            Floor: this.chooseFloor
          }
        )
      }
      this.tabletData.forEach((item) => {
        // eslint-disable-next-line eqeqeq
        const index = this.allowList.AllowTablets.findIndex((x) => x.TabletId == item.TabletId)
        if (index >= 0) this.allowList.AllowTablets.splice(index, 1)
      })
    },
    addHousehold () {
      this.chooseHousehold.forEach((item) => {
        // eslint-disable-next-line eqeqeq
        const household = this.tabletData.find((x) => x.TabletId == item)
        // eslint-disable-next-line eqeqeq
        const isChoosed = this.allowList.AllowTablets.find((x) => x.TabletId == item)
        if (household && !isChoosed) this.allowList.AllowTablets.push(household)
      })
    },
    checkTowerAllChoose () {
      // eslint-disable-next-line eqeqeq
      if (this.allowList.AllowTags && this.allowList.AllowTags.length == this.towerData.length) {
        this.allowList.AccessMode = 1
      }
    },
    checkFloorAllChoose () {
      let allChoosed = true
      this.floorData.forEach((item) => {
        // eslint-disable-next-line eqeqeq
        const isChoosed = this.allowList.AllowFloors.find((x) => x.Floor == item.Floor && x.FloorTag == this.chooseTower)
        if (!isChoosed) allChoosed = false
      })
      if (allChoosed && this.floorData?.length > 0) {
        this.allowList.AllowTags.push(this.chooseTower)
        this.floorData.forEach((item) => {
          // eslint-disable-next-line eqeqeq
          const index = this.allowList.AllowFloors.findIndex((x) => x.Floor == item.Floor && x.FloorTag == this.chooseTower)
          if (index > -1) this.allowList.AllowFloors.splice(index, 1)
        })
      }
    },
    checkHouseholdAllChoose () {
      let allChoosed = true
      this.tabletData.forEach((item) => {
        // eslint-disable-next-line eqeqeq
        const isChoosed = this.allowList.AllowTablets.find((x) => x.TabletId == item.TabletId)
        if (!isChoosed) allChoosed = false
      })
      if (allChoosed && this.tabletData?.length > 0) {
        this.allowList.AllowFloors.push(
          {
            Id: 1546,
            FloorTag: this.chooseTower,
            Floor: this.chooseFloor
          }
        )
        this.tabletData.forEach((item) => {
          // eslint-disable-next-line eqeqeq
          const index = this.allowList.AllowTablets.findIndex((x) => x.TabletId == item.TabletId)
          if (index > -1) this.allowList.AllowTablets.splice(index, 1)
        })
      }
    },
    deleteTower (tower) {
      // eslint-disable-next-line eqeqeq
      const index = this.allowList.AllowTags.findIndex((x) => x == tower)
      if (index > -1) this.allowList.AllowTags.splice(index, 1)
    },
    deleteFloor (floor) {
      // eslint-disable-next-line eqeqeq
      const index = this.allowList.AllowFloors.findIndex((x) => x.Floor == floor.Floor && x.FloorTag == floor.FloorTag)
      if (index > -1) this.allowList.AllowFloors.splice(index, 1)
    },
    deleteHousehold (household) {
      // eslint-disable-next-line eqeqeq
      const index = this.allowList.AllowTablets.findIndex((x) => x.TabletId == household.TabletId)
      if (index > -1) this.allowList.AllowTablets.splice(index, 1)
    },
    clearHousehold () {
      this.allowList.AccessMode = 2
      this.allowList.AllowTablets = []
      this.allowList.AllowFloors = []
      this.allowList.AllowTags = []
      this.chooseTower = ''
      this.chooseFloor = ''
      this.chooseHousehold = []
    },
    checkAllowListChange () {
      const allowFloorsSort = (a, b) => {
        if (a.FloorTag !== b.FloorTag) return a.FloorTag > b.FloorTag ? 1 : -1
        return a.Floor > b.Floor ? 1 : -1
      }
      const allowTabletsSort = (a, b) => {
        return a.TabletId > b.TabletId ? 1 : -1
      }
      // 部分戶別會有多餘的資訊 所以用map過濾掉
      const allowTabletsMap = (item) => {
        return {
          TabletId: item.TabletId,
          TabletNote: item.TabletNote
        }
      }
      const { AllowFloors: allowFloorsBack, AllowTablets: allowTabletsBack, AllowTags: allowTagsBack } = this.allowListBack
      const { AllowFloors: allowFloors, AllowTablets: allowTablets, AllowTags: allowTags } = this.allowList
      const allowFloorsCopy = JSON.parse(JSON.stringify(allowFloors))
      const allowTabletsCopy = JSON.parse(JSON.stringify(allowTablets))
      const allowTagsCopy = JSON.parse(JSON.stringify(allowTags))
      const allowFloorChange = JSON.stringify(allowFloorsBack.sort(allowFloorsSort)) !== JSON.stringify(allowFloorsCopy.sort(allowFloorsSort))
      const allowTabletsChange = JSON.stringify(allowTabletsBack.sort(allowTabletsSort).map(allowTabletsMap)) !== JSON.stringify(allowTabletsCopy.sort(allowTabletsSort).map(allowTabletsMap))
      const allowTagsChange = JSON.stringify(allowTagsBack.sort()) !== JSON.stringify(allowTagsCopy.sort())
      return allowFloorChange || allowTabletsChange || allowTagsChange || this.allowListBack.AccessMode !== this.allowList.AccessMode
    },
    storeHoudehold () {
      const dataHasChange = this.checkAllowListChange()
      if (!dataHasChange) {
        this.$message({
          message: '名單已更新',
          type: 'success'
        })
        return
      }
      const sendData = JSON.parse(JSON.stringify(this.allowList))
      sendData.AllowFloors = sendData.AllowFloors.map((x) => { return { Tag: x.FloorTag, Floor: x.Floor } })
      sendData.AllowTablets = sendData.AllowTablets.map((x) => x.TabletId)
      this.allowListBack = this.allowList
      apiIntercom.Sentry.PutSentryAllowlist(this.chooseSentryID, sendData).then((res) => {
        this.$message({
          message: '名單已更新',
          type: 'success'
        })
        this.getDefaultAllowlist(this.chooseSentryID, true)
      }).catch((err) => {
        this.$message.error('名單更新失敗!!', this.$t('General.PleaseContactUs'))
        console.log(err)
      })
    },
    closeHousehold () {
      if (!this.checkAllowListChange()) {
        // if (JSON.stringify(this.allowList) == JSON.stringify(this.allowListBack)) {
        this.softwareSentryActiveName = 'information'
        this.hardwareSentryActiveName = 'information'
        this.chooseTower = ''
        this.chooseFloor = ''
        this.chooseHousehold = []
        this.isSentryManagementDialogShow = false
        this.isHardwareSentryManagementDialogShow = false
        this.isSoftDoorManagementDialogShow = false
      } else this.checkNoSaveClose()
    },
    startDraggable () {
      this.initSort()
    },
    endDraggable () {
      this.sortable.destroy()
    },
    initSort () {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = new Sortable(el, {
        onEnd: (evt) => {
          const oldIndex = evt.oldIndex
          const newIndex = evt.newIndex
          const temp = this.sortListData[oldIndex]
          this.sortListData.splice(oldIndex, 1)
          this.sortListData.splice(newIndex, 0, temp)
        }
      })
    },
    handleSortSKollectList () {
      this.ListData = this.sortListData.concat()
      this.ListData.forEach((item, index) => {
        item.Sort = index + 1
      })
      apiIntercom.Sentry.PutSentriesSort({ Sentries: this.ListData }).then((res) => {
        const { data } = res
        // eslint-disable-next-line eqeqeq
        if (data.Status == 1) {
          this.listSortable = false
          this.$message({
            message: '排序已更新',
            type: 'success'
          })
        } else this.$message.error('排序更新更新失敗!!', this.$t('General.PleaseContactUs'))
      }).catch((err) => {
        this.$message.error('排序更新更新失敗!!', this.$t('General.PleaseContactUs'))
      })
    },
    changeListSortable (e) {
      if (!this.listSortable) this.listSortable = !this.listSortable
      else {
        // eslint-disable-next-line eqeqeq
        if (JSON.stringify(this.ListData) == JSON.stringify(this.sortListData)) this.listSortable = !this.listSortable
        else this.checkNoSaveClose()
      }
    },
    checkNoSaveClose () {
      this.$confirm('若直接離開，您的異動資料將不會儲存', '尚未儲存', {
        confirmButtonText: '離開',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: '取消',
        closeOnClickModal: false
      }).then(action => {
        this.softwareSentryActiveName = 'information'
        this.hardwareSentryActiveName = 'information'
        this.chooseTower = ''
        this.chooseFloor = ''
        this.chooseHousehold = []
        this.listSortable = false
        this.isSentryManagementDialogShow = false
        this.isHardwareSentryManagementDialogShow = false
        this.isSoftDoorManagementDialogShow = false
      }).catch(() => {})
    },
    changeCallBack (id, defaultCallBack, name) {
      if (defaultCallBack) console.log(id, 'true')
      else console.log(id, 'false')
      console.log(defaultCallBack)

      this.$confirm(defaultCallBack ? this.$t('SentryManagement.ChangeCallBackConfirmTitle2') : this.$t('SentryManagement.ChangeCallBackConfirmTitle1', { name }), '', {
        confirmButtonText: defaultCallBack ? '確定關閉' : '確認',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async (res) => {
        if (defaultCallBack) {
          await apiIntercom.Sentry.DeleteCommunityMainCallBack(id).then(() => {
            this.getSentryList()
          }).catch((error) => {
            let errorMessage = '切換失敗'
            if (error?.response?.data?.ErrorMessage?.Description) errorMessage = error.response.data.ErrorMessage.Description
            this.$message({
              message: errorMessage,
              type: 'warning'
            })
          })
        } else {
          await apiIntercom.Sentry.PutCommunityMainCallBack(id).then(() => {
            this.$message({
              message: '切換成功',
              type: 'success'
            })
            this.getSentryList()
          }).catch((error) => {
            let errorMessage = '切換失敗'
            if (error?.response?.data?.ErrorMessage?.Description) errorMessage = error.response.data.ErrorMessage.Description
            this.$message({
              message: errorMessage,
              type: 'warning'
            })
          })
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="sass" scoped>
.tooltip-href
  color: unset
  text-decoration: underline
#sentryManagement
  padding: 20px 0 10px
  height: 100%
  .disabled
    opacity: 0.3
    pointer-events: none
  .click-disabled
    opacity: 0.3
  .transfer-description
    display: flex
    padding: 15px 10px
    .description-title
      margin-right: 20px
      font-weight: bold
    .description-content
      div
        margin-bottom: 5px

  .title_bar
    display: flex
    justify-content: space-between
    align-items: center
    margin: 0 0 20px 0

    .sort-ctrl
      button, span
        margin-left: 5px
  .newslist
    font-size: 15px
    ::v-deep .el-table
      +basicTable
    .deviceCount
      color: $mainColor
    .icon-check-circle
      color: $correctColor
    .icon-filled-info
      color: $SystemYellow

  ::v-deep .el-dialog
    +basicDialog
    border-radius: 8px
    .el-dialog__header
      .dialog-title
        font-size: 25px
        font-weight: bold
        margin-bottom: 5px
      .dialog-subTitle
        font-size: 15px
        color: #666666
      .el-icon
        font-size: 25px
        color: #333333
        font-weight: bold
    .el-dialog__body
      color: #333333
      .createSnDialogContentTitle
        font-size: 19px
        font-weight: bold
        margin-bottom: 20px
        text-align: center
      .createSnDialogContent
        display: flex
        text-align: center
        justify-content: center
        margin-bottom: 40px
        line-height: 1.3
        &.dash-block
          .dash
            width: 48px
            height: 4px
            background-color: #666666
            border-radius: 4px
            margin: 0 12px
        &.sn-block
          font-weight: bold
          font-size: 80px
          .sn
            letter-spacing: 20px
      .createSnDialogNote
        margin-left: 84px
        margin-bottom: 5px
        line-height: 1.3
        b
          font-weight: bold
      .dialog-label
        margin-bottom: 5px
      .createSentryDialogInput
        margin-bottom: 5px
      .deleteSentryDialogContent
        padding: 5px 0
      .sentryManagementDialogInput
        margin-bottom: 40px
        margin-right: 8px
        width: 75%
      .sentryDeviceListTitle
        margin-bottom: 8px
        font-size: 15px
        font-weight: bold
      .el-table
        margin-bottom: 25px
        thead
          color: #333333
          th
            background-color: $bgDark3
        .cell
          word-wrap: break-word
      .editDeviceDialogInput
        margin-bottom: 40px
      .editDeviceDialogTextarea
        margin-bottom: 5px
      .editDeviceDialogCheckbox
        margin-top: 35px
        margin-bottom: 5px
      .household-filter
        display: flex
      .household-select
        padding-right: 5px
    .el-dialog__footer
      text-align: center

.el-icon-d-caret
  padding: 3px
  font-size: 18px
  color: #fff
  background-color: #3faa88
  border-radius: 50%

  &:hover
    cursor: move

#feeTab
  text-align: center
  ::v-deep .el-tabs
    +basicTabs
    &__item
      min-width: 130px
      span
        width: 100%
        display: inline-block
::v-deep .el-select__tags
  & .el-tag
    max-width: 90px
    text-overflow: ellipsis
    overflow: hidden
.household-tags-content
  padding-block: 20px
  min-height: 200px
  max-height: 35vh
  overflow-y: auto
::v-deep .el-tag
  margin-right: 3px
  margin-top: 3px
.allow-hint
  padding: 10px 20px 20px
.no-household-content
  padding-block: 20px
  text-align: center
  font-weight: bold
  opacity: .6
.checkclose-ctrl-btns,
.household-ctrl-btns
  display: flex
  justify-content: end
  button
    margin-left: 10px
ul, li
  list-style: unset
li
  padding-block: 3px
  font-size: 14px
  color: #666666

::v-deep .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label
  cursor: pointer !important

.store-btn[disabled]
  opacity: 0.3
  pointer-events: none
  cursor: not-allowed !important
  background: #fafafa !important
</style>
<style lang="sass">
.message-box-alert
  +alert
</style>
